module.exports = __webpack_public_path__ + "img/base.ea460638.png";